import { Fragment } from "react/jsx-runtime";
import { DocumentTitle, Href, ListingOfRecords } from "../../../../Constants/Constants";
import { DocumentsData } from "../../../../Data/Messenger/Messenger";
import CommonLeftHeading from "./Common/CommonLeftHeading";
import { Download } from "react-feather";

const Document = () => {
  return (
    <Fragment>
      <CommonLeftHeading title={DocumentTitle} sunTitle={ListingOfRecords} search />
      <ul className="chat-main">
        {DocumentsData.map((doc, index) => (
          <li key={index} className="border-0">
            <div className="chat-box">
              <div className="d-flex">
                <div className="profile">
                  <a className={`icon-btn ${doc.bgColorClass} btn-xl pull-right`} href={Href}>
                    <i className={`fa ${doc.iconClass}`} />
                  </a>
                </div>
                <div className="details">
                  <h4>{doc.title}</h4>
                  <h5>{doc.date}</h5>
                </div>
                <div className="flex-grow-1">
                  <a className="icon-btn btn-outline-light btn-sm pull-right" href={Href}><Download /></a>
                  <a className="icon-btn btn-outline-light btn-sm pull-right" href={Href}><i className="fa fa-share" /></a>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </Fragment>
  );
};

export default Document;
